import { DayType } from 'app/constants/dayType'

export const getDayTypeName = (
  dayType: DayType,
  translate: (string) => string,
): string => {
  const text: string = DayType[dayType]
  return translate(`dayType.${text}`)
}
